// Service-area pages (/areas/:slug). Content is deliberately factual: no invented projects, clients or statistics.
export const AREAS = [
  {
    slug: 'sydney-cbd',
    name: 'Sydney CBD',
    metaTitle: 'Rope Access Services Sydney CBD | ProClimb Solutions',
    metaDescription:
      'IRATA Level 3 rope access for Sydney CBD buildings: high-rise window and facade cleaning, remedial work, glazing, height safety and 24/7 emergency response. Call 0426 920 301.',
    headline: 'Rope Access Services in Sydney CBD',
    intro: [
      'Dense streets, tight loading docks and busy foot traffic make traditional access hard in the CBD. Rope access lets our technicians reach glass towers, podiums and heritage facades without scaffolding or road closures, with minimal disruption to tenants.',
      'ProClimb Solutions is based in Sydney and works on commercial towers, hotels, residential strata and mixed-use buildings across the city centre.',
    ],
    suburbs: ['Sydney CBD', 'Barangaroo', 'Pyrmont', 'Ultimo', 'Haymarket', 'Darling Harbour', 'Surry Hills'],
    focus: ['High-rise window and facade cleaning', 'Glazing and panel replacement', 'Sealing and remedial repairs', 'Height safety inspection and anchor points', 'Emergency make-safe works'],
    image: 'hero',
  },
  {
    slug: 'eastern-suburbs',
    name: 'Eastern Suburbs',
    metaTitle: 'Rope Access Eastern Suburbs Sydney | ProClimb Solutions',
    metaDescription:
      'Rope access for the Eastern Suburbs of Sydney: apartment towers, strata buildings and luxury homes. Facade cleaning, remedial work, glazing and emergency response from a local team in Eastlakes.',
    headline: 'Rope Access Services in the Eastern Suburbs',
    intro: [
      'Our office is in Eastlakes, so the Eastern Suburbs are on our doorstep. We work on apartment towers and strata complexes in the Mascot, Zetland and Waterloo corridor, and on waterfront and architect-designed homes along the harbour and coast.',
      'Coastal weather is hard on facades. Regular cleaning, sealing and inspection by rope access keeps buildings protected without the cost and noise of scaffolding.',
    ],
    suburbs: ['Eastlakes', 'Mascot', 'Zetland', 'Waterloo', 'Kensington', 'Randwick', 'Bondi Junction', 'Coogee', 'Double Bay', 'Vaucluse', 'Point Piper'],
    focus: ['Strata and apartment facade cleaning', 'Sealing, caulking and remedial work', 'Glazing and panel replacement', 'Luxury home exterior services', 'Emergency response'],
    image: 'facade',
  },
  {
    slug: 'north-shore',
    name: 'North Shore',
    metaTitle: 'Rope Access North Shore Sydney | ProClimb Solutions',
    metaDescription:
      'Rope access services across Sydney North Shore: North Sydney, Chatswood, St Leonards and Mosman. High-rise cleaning, remedial work, glazing, height safety and emergency response.',
    headline: 'Rope Access Services on the North Shore',
    intro: [
      'From the office towers of North Sydney, Chatswood and St Leonards to waterfront homes in Mosman, the North Shore has a mix of tall buildings and complex residential sites that suit rope access.',
      'We deliver cleaning, remedial work, glazing and height safety works with certified technicians and clear safety planning for each site.',
    ],
    suburbs: ['North Sydney', 'Chatswood', 'St Leonards', 'Crows Nest', 'Lane Cove', 'Neutral Bay', 'Milsons Point', 'Mosman'],
    focus: ['Commercial tower window and facade cleaning', 'Remedial and sealing work', 'Glazing and panel installation', 'Luxury home exterior services', 'Height safety systems'],
    image: 'hero',
  },
  {
    slug: 'parramatta-western-sydney',
    name: 'Parramatta & Western Sydney',
    metaTitle: 'Rope Access Parramatta & Western Sydney | ProClimb Solutions',
    metaDescription:
      'Rope access for Parramatta, Sydney Olympic Park and Western Sydney: high-rise window cleaning, facade work, glazing, height safety and emergency response by IRATA Level 3 technicians.',
    headline: 'Rope Access Services in Parramatta & Western Sydney',
    intro: [
      'Parramatta and the wider Western Sydney region are seeing more high-rise residential, commercial and mixed-use buildings. Rope access gives owners and strata managers a safer, faster way to maintain them.',
      'We service buildings across Parramatta, Sydney Olympic Park and surrounding suburbs, from routine maintenance to urgent make-safe works.',
    ],
    suburbs: ['Parramatta', 'Sydney Olympic Park', 'Homebush', 'Westmead', 'Blacktown', 'Liverpool', 'Penrith'],
    focus: ['High-rise window cleaning', 'Facade and balcony maintenance', 'Glazing and sealing', 'Height safety inspections', 'Emergency response'],
    image: 'facade',
  },
  {
    slug: 'inner-west',
    name: 'Inner West',
    metaTitle: 'Rope Access Inner West Sydney | ProClimb Solutions',
    metaDescription:
      'Rope access for Sydney Inner West buildings: facade cleaning, remedial work, glazing, height safety and emergency response for strata, commercial and industrial properties.',
    headline: 'Rope Access Services in the Inner West',
    intro: [
      'The Inner West combines apartment developments, warehouse conversions and commercial buildings, often on tight sites where scaffolding or swing stages are hard to set up.',
      'Rope access reaches these buildings with a small footprint and a short setup time, so the work gets done with little impact on residents and neighbours.',
    ],
    suburbs: ['Newtown', 'Marrickville', 'Leichhardt', 'Ashfield', 'Burwood', 'Strathfield', 'Rhodes'],
    focus: ['Strata building cleaning and maintenance', 'Sealing and remedial work', 'Glazing and panel replacement', 'Bird control and facade protection', 'Emergency response'],
    image: 'hero',
  },
  {
    slug: 'newcastle',
    name: 'Newcastle',
    metaTitle: 'Rope Access Newcastle NSW | ProClimb Solutions',
    metaDescription:
      'Rope access services in Newcastle and the Hunter: facade cleaning, remedial work, glazing, height safety and emergency response by certified technicians travelling from Sydney.',
    headline: 'Rope Access Services in Newcastle',
    intro: [
      'We regularly work in Newcastle and surrounding regions, travelling from Sydney with our own certified team and equipment.',
      'Newcastle’s mix of waterfront apartments, commercial buildings and industrial sites makes rope access a practical alternative to scaffolding for cleaning, repairs and inspections.',
    ],
    suburbs: ['Newcastle CBD', 'Honeysuckle', 'Newcastle East', 'Merewether', 'Charlestown'],
    focus: ['Facade and window cleaning', 'Remedial and sealing work', 'Height safety inspection', 'Glazing and panel work', 'Emergency response'],
    image: 'facade',
  },
  {
    slug: 'wollongong',
    name: 'Wollongong',
    metaTitle: 'Rope Access Wollongong NSW | ProClimb Solutions',
    metaDescription:
      'Rope access services in Wollongong and the Illawarra: facade cleaning, remedial work, glazing, height safety and emergency response by certified technicians.',
    headline: 'Rope Access Services in Wollongong',
    intro: [
      'We work in Wollongong and the Illawarra, travelling from Sydney with our own team and equipment for planned maintenance and urgent works.',
      'Salt air and coastal weather wear on facades, sealants and glazing. Regular inspection and maintenance by rope access helps catch problems early.',
    ],
    suburbs: ['Wollongong', 'Fairy Meadow', 'North Wollongong', 'Corrimal', 'Shellharbour'],
    focus: ['Facade and window cleaning', 'Sealing and remedial work', 'Height safety inspection', 'Glazing and panel work', 'Emergency response'],
    image: 'hero',
  },
];

export const getArea = (slug) => AREAS.find((a) => a.slug === slug);
